import { addDays } from 'date-fns';
import { safeParseJSON } from '@helsenorge/core-utils/date-fns-utils';
import { hasCookieWithSuffix, deleteCookie, getSuffix } from '@helsenorge/framework-utils/cookie';
import { getJsonCookieValue, setSharedJsonCookie } from '../survey-invitation/utils';
const COOKIE_CONSENT_COOKIE_NAME = 'HN-Cookie-Consent';
const COOKIE_CONSENT_EXPIRES_IN_DAYS = 365;
/**
 * Sjekk om brukeren har en cookie som lagrer cookie-samtykke
 */
export const hasConsentCookie = () => {
    return hasCookieWithSuffix(COOKIE_CONSENT_COOKIE_NAME);
};
/**
 * Les data fra cookie som lagrer brukerens cookie-samtykke
 */
const getCookieConsent = () => {
    const value = getJsonCookieValue(COOKIE_CONSENT_COOKIE_NAME);
    if (value) {
        return value;
    }
    deleteCookie(COOKIE_CONSENT_COOKIE_NAME);
};
/**
 * Sjekk om brukeren har samtykket til analyse-cookies
 */
export const hasAcceptedAnalyticsCookies = () => {
    const cookieData = getCookieConsent();
    return cookieData?.AnalyticsCookies === true;
};
/**
 * Sjekk om brukeren har samtykket til video-cookies
 */
export const hasAcceptedVideoCookies = () => {
    const cookieData = getCookieConsent();
    return cookieData?.VideoCookies === true;
};
/**
 * Hent brukerens cookie-samtykker
 */
export const getCookieConsentOptions = () => {
    return {
        VideoCookies: hasAcceptedVideoCookies(),
        AnalyticsCookies: hasAcceptedAnalyticsCookies(),
    };
};
/**
 * Hent dato for når cookie-samtykket utløper
 */
export const getCookieConsentExpires = () => {
    const cookieData = getCookieConsent();
    return safeParseJSON(cookieData?.Expires);
};
/**
 * Lagre brukerens cookie-samtykker i en cookie på tvers av helsenorge.no-domenene
 * @param options Brukerens cookie-samtykker
 */
export const saveCookieConsentCookie = (options) => {
    const cookieData = {
        ...options,
        Expires: addDays(new Date(), COOKIE_CONSENT_EXPIRES_IN_DAYS).toISOString(),
    };
    setSharedJsonCookie(getSuffix(COOKIE_CONSENT_COOKIE_NAME), cookieData, COOKIE_CONSENT_EXPIRES_IN_DAYS);
};
